import angular from 'angular';
import BackdropRailController from './bd-rail.controller';
import BackdropRailItem from './bd-rail-item/bd-rail-item.component';

import './bd-rail.styles.scss';

const BackdropRailTemplate = /* html */ `
  <div class="main-content-wrap">
    <div class="nav-rail" ng-class="{ 'no-items': $ctrl.items.length <= 1 }">
      <div class="nav-btn-wrap">
        <button
          ng-if="($ctrl.mainAction || $ctrl.mainLink) && $ctrl.permissionForMainAction"
          ng-click="$ctrl.mainLink ? $ctrl.navigate($ctrl.mainLink) : $ctrl.mainAction()"
          class="main-btn"
        >
          <div class="icon" ng-if="$ctrl.mainIcon">
            <i class="{{ $ctrl.mainIcon }}"></i>
          </div>
        </button>

        <button
          ng-repeat="menuItem in $ctrl.items track by $index"
          ng-click="$ctrl.selectItem(menuItem)"
          ng-class="{'active': menuItem.active}"
        >
          <div class="icon">
            <i class="{{menuItem.icon}}"></i>
          </div>
          <span>{{ menuItem.title }}</span>
        </button>
      </div>
    </div>

    <div class="">
      <div class="" ng-transclude></div>
    </div>
  </div>
`;

export const BackdropRailComponent = {
  selector: 'bdRail',
  controller: BackdropRailController,
  bindings: {
    jump: '@',
    changeFunction: '&?',
    mainAction: '&?',
    mainLink: '@?',
    mainIcon: '@?',
    mainPermissions: '@?',
  },
  transclude: true,
  template: BackdropRailTemplate,
};

export default angular.module('autoboard.backdropRail', [BackdropRailItem])
  .component(BackdropRailComponent.selector, BackdropRailComponent)
  .name;
